import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { Candidato } from 'src/app/models/candidato.model';
import { CandidatosCsvDTO } from 'src/app/models/candidatosCsvDTO.model';
import { CanditadosService } from 'src/app/services/canditados.service';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { Utils } from 'src/app/utils/utils';

declare var window: any;
@Component({
  selector: 'cadastro-candidato-assistente',
  templateUrl: './candidato-assistente.component.html',
  styleUrls: ['./candidato-assistente.component.css']
})
export class CandidatoAssistenteComponent implements OnInit {
  idEleicao: any;
  novoCandidato: any;
  formCadastroCandidato: FormGroup;
  editandoCandidato: boolean = false;
  token: any;
  idCandidatoEditando: any;
  idCandidatoExcluindo: any;
  listaCargos: any[] = [];
  select: FormGroup;
  candidatosArray: CandidatosCsvDTO[] = [];
  newCandidatosArray: CandidatosCsvDTO[] = [];
  listaCandidatos: any;
  btOff: boolean = false;
  list: any;
  public imageSrc: string = '';
  carregandoCandidatos: boolean;
  carregandoCandidatosEdit: boolean;
  votoJustificavel: boolean = false;
  parametroJustificativa: any;
  isSubmit: boolean = false;
  displayModalExclusaoCandidatura: boolean = false;
  formModal: any;
  eleicaoParametrizacao: any;
  justificativaExclusao: any;

  constructor(
    public eleicaoService: EleicaoService,
    public canditadosService: CanditadosService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    public utils: Utils,
  ) { }

  ngOnInit() {
    this.token = sessionStorage.getItem("token");
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicaoParametrizacao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.listarCandidatosExistentes();
    //this.openTextArea();
    this.listarCargosEleicao();

    this.formCadastroCandidato = new FormGroup({
      nome: new FormControl(),
      cpf: new FormControl(),
      curriculum: new FormControl(),
      votoJustificavel: new FormControl(),
      parametroJustificativa: new FormControl(),
      cargo: new FormControl()
    });

    this.formCadastroCandidato = this.formBuilder.group({
      nome: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      cpf: [null, this.isValidCPF],
      curriculum: [''],
      votoJustificavel: ['false'],
      parametroJustificativa: [''],
      cargo: ['', [Validators.required]]
    });

    this.novoCandidato = new Candidato;
    this.select = this.formBuilder.group({
      select: ['']
    });
    this.formModal = new window.bootstrap.Modal(
      document.getElementById('myModal2')
    );
  }

  public listarCargosEleicao() {
    this.eleicaoService.getCargosByIdEleicao(this.idEleicao, this.token).then((res: []) => {
      if (res != null && res.length > 0) {
        this.listaCargos = res;
        this.spinner.hide();
      } else {
        this.messageService.add({ key: 'toast', severity: 'info', summary: 'Informação', detail: 'Ainda não existem cargos cadastros para essa eleição' });
        this.spinner.hide();
      }
    })
  }
  public listarCandidatosExistentes() {
    this.carregandoCandidatos = true;
    this.canditadosService.getCandidatosByIdEleicaoLite(this.idEleicao, this.token).then((res: []) => {
      if (res != null && res.length > 0) {
        this.listaCandidatos = res;
        this.spinner.hide();
        this.carregandoCandidatos = false;
      } else {
        this.listaCandidatos = [];// forçando zerando no front pra não continuar exibindo se a resposta zerar do back.
        if(!sessionStorage.getItem("temCandidaturas"))
        {this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Ainda não existem candidatos cadastrados para essa eleição' });  
      }this.carregandoCandidatos = false;
        this.spinner.hide();
      }
    })
  }
  // o submit chama a abertura do modal e as funçooes do sim ou não seguem com o envioCandidato

  validaCurriculo(){ // chamado no click do submit
    if (this.formCadastroCandidato.get("curriculum").value == null || this.utils.noWhitespaceValidatorString2(this.formCadastroCandidato.get("curriculum").value)) {
      this.formModal.show(); //se o campo curriculum estiver vazio, abre o modal com as opções
    } else {
      this.envioCandidato(); // se não estiver vazio, ele faz o envio/persistência
    }
  }
  prosseguirSemCurriculum() { //ao clicar em "SIM" no modal
    this.formModal.hide();
    this.envioCandidato(); // submete
  }
  pararSubmit() { // ao clicar "Não"
    this.formModal.hide();
    return false; // para aqui e não executa nenhuma ação
  }

  public envioCandidato() {    
    this.isSubmit = true;
    if (!this.formCadastroCandidato.valid) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }

    this.novoCandidato.votoJustificavel = this.formCadastroCandidato.get("votoJustificavel").value;
    this.novoCandidato.parametroJustificativa = this.formCadastroCandidato.get("votoJustificavel").value == 'true' ? this.formCadastroCandidato.get("parametroJustificativa").value : '';
    if (this.novoCandidato.votoJustificavel === 'true' && (this.novoCandidato.parametroJustificativa == null || this.novoCandidato.parametroJustificativa.trim() == '')) {
      return this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Atenção', detail: "É necessário preencher o campo parametro justificativa caso o voto seja justificável." })
    }
    this.novoCandidato.nome = this.formCadastroCandidato.get("nome").value;
    this.novoCandidato.cpf = this.formCadastroCandidato.get("cpf").value;
    this.novoCandidato.curriculum = this.formCadastroCandidato.get("curriculum").value;
    this.novoCandidato.eleicao = { id: this.idEleicao };
    this.novoCandidato.imagem = this.imageSrc;
    this.novoCandidato.cargo = { "id": +this.formCadastroCandidato.get("cargo").value };

    if (this.editandoCandidato == false) {
      this.btOff = true;
      document.body.style.cursor = 'wait';
      this.canditadosService.cadastrarCandidatoEleicao(this.novoCandidato, this.token).then(() => { //endpoint de criação.
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Candidato criado com sucesso!' });
        this.btOff = false;
        document.body.style.cursor = 'default';
        this.fixAlterarImg(document.getElementById("imageCandidato"));
        this.formCadastroCandidato.reset();
        this.listarCandidatosExistentes();
        this.isSubmit = false;
      }, error => {
        this.btOff = false;
        document.body.style.cursor = 'default';
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      })
    } else {
      this.canditadosService.editarCandidatoEleicao(this.novoCandidato, this.token, this.idCandidatoEditando).then(() => { //endpoint de edição.
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Candidato editado com sucesso!' });
        this.fixAlterarImg(document.getElementById("imageCandidato"));
        this.formCadastroCandidato.reset();
        this.listarCandidatosExistentes();
        this.isSubmit = false;
        this.cancelarEdicao();
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      })
    }
  }

  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    uploadUrl: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertVideo']
    ]
  };

  public editarCandidato(candidato) {
    this.editandoCandidato = true;
    this.idCandidatoEditando = candidato.id;
    this.carregandoCandidatosEdit = true;
    this.votoJustificavel = this.formCadastroCandidato.get('votoJustificavel').value;
    this.canditadosService.getCandidadosById(candidato.id, this.token).then((res: any) => {
      this.formCadastroCandidato.patchValue(res);
      this.formCadastroCandidato.get("cargo").patchValue(res.cargo.id);
      this.carregandoCandidatosEdit = false;
    }, err => {
      this.carregandoCandidatosEdit = false;
    })
    // this.imageSrc = candidato.imagem;
  }
  public cancelarEdicao() {
    this.editandoCandidato = false;
    this.formCadastroCandidato.reset();
  }
  public fixAlterarImg(input: any) {
    this.imageSrc = '';
    input.value = '';
  }
  public showModalExclusaoCandidatura(idCandidato){
    if(!this.eleicaoParametrizacao.temCandidaturas){
      this.excluirCandidato(idCandidato)
    }
    else{
      this.justificativaExclusao = '';
      this.idCandidatoExcluindo = idCandidato;
      this.displayModalExclusaoCandidatura = true;
    }
  }
  public enviarEmailEExcluir(justificativaExclusao){
    this.canditadosService.emailExclusaoCandidatura(this.idCandidatoExcluindo, justificativaExclusao, this.token).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Candidato excluído da eleição com sucesso!' });
      this.btOff = false;
      this.excluirCandidato(this.idCandidatoExcluindo);
      this.displayModalExclusaoCandidatura = false;
    }, err => {
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: err + '.' });
    })
  }
  public excluirCandidato(idCandidato) {
    this.btOff = true;
    document.body.style.cursor = 'wait';
    this.canditadosService.excluirCandidatoEleicao(idCandidato, this.token).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Candidato excluído da eleição com sucesso!' });
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.listarCandidatosExistentes();
    }, err => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: err + '.' });
    })
  }

  baixarTemplate() {
    let csvHeader = 'nome;cpf;cargo;curriculo;votoJustificavel;parametro justificativa'
    this.utils.baixarModeloCsv(csvHeader, "candidato")
  }

  isValidCPF(control: FormControl) {
    let cpf = (control.value || '');
    if (!cpf) {
      return null;
    }
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '' || cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999") {
      return { 'invalid': true };
    }
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(9))) {
      return { 'invalid': true };
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(10))) {
      return { 'invalid': true };
    }
    return null;
  }


}